module.exports = __webpack_public_path__ + "img/gaizao1.3f0bbffc.png";